import React from 'react'
import faq from "../data/faq.json";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Typography from '@mui/material/Typography';
import ReactMarkdown from "react-markdown";
import { Button } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  height:"90vh",
  overflowY:"auto",
  p: 4,
};

function ChildModal({item}) {
// Define image paths
const imageMap = {
  yesNoImg: `${process.env.PUBLIC_URL}/Images/FAQ/yes-no.png`,
  ssImg: `${process.env.PUBLIC_URL}/Images/FAQ/ssimage.png`
};
// Function to replace all placeholders dynamically
const replacePlaceholders = (text, replacements) => {
  return text.replace(/{{(.*?)}}/g, (match, key) => replacements[key] || match);
};
// Replace placeholders in fullanswer
const fullans = replacePlaceholders(item.fullanswer, imageMap);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  

  return (
    <React.Fragment>
      <Button onClick={handleOpen} sx={{textTransform:"none"}}>Read More..</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={style}>
          <Button onClick={handleClose} sx={{textTransform:"none"}}>&#8592; Go Back</Button>
          <h2 id="child-modal-title" style={{fontSize:"1.4rem"}}>{item.question}</h2>
          <br/>
          <p id="child-modal-description" style={{fontSize:"0.9rem"}}>
          <ReactMarkdown>
              {fullans}
          </ReactMarkdown>
          </p>
        </Box>
      </Modal>
    </React.Fragment>
  );
}

const FAQ = ({open, handleClose}) => {

  return (
    <Modal
        open={open}
        onClose={()=>handleClose()}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
          <Typography id="modal-modal-title" variant="h4" component="h2">
            Frequently Asked Questions
          </Typography>
          <a href="/CommsBuilderFAQ.docx"
           download="CommsBuilderFAQ.docx">
            Download FAQ File
          </a>
          <CloseIcon sx={{ cursor: "pointer" }} onClick={handleClose} />
          </div>

          <div style={{marginTop:"10px"}}>

            {faq.map((section,idx)=>(
              <div key={idx}>
                <Typography variant='h5' sx={{marginY:"15px"}}>
                    {section.title}
                </Typography>
                {section.data.map((item,i)=>               
              <Accordion key={i}>
              <AccordionSummary
                expandIcon={<ArrowDropDownIcon/>}
                aria-controls="panel1-content"
                id="panel1-header"
              >
                <Typography>{item.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <p style={{fontSize:"0.9rem"}}>
                  <ReactMarkdown>
                    {item.answer}
                  </ReactMarkdown>
                </p>  
                  {item.fullanswer &&
                   <ChildModal item={item}/>
                   }
              </AccordionDetails>
            </Accordion>
            )}
            </div>))}
      
            </div>
        </Box>
      </Modal>
  )
}

export default FAQ